import useClickAwayListener from '@/utils/use-click-away-listener';
import { RefObject, Dispatch, SetStateAction, useState, useRef, useEffect } from 'react';

export const useTimePicker = (
  ref: RefObject<HTMLElement | null> | null,
  optionsRef: RefObject<HTMLElement | null> | null
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [isFocused, setIsFocused] = useState(false);
  const timeRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    timeRef.current = (ref?.current?.querySelectorAll('input.react-datepicker-time__input')?.[0] ||
      null) as HTMLElement | null;
  }, [ref]);

  useClickAwayListener({
    ref: timeRef,
    open: true,
    onPointerDownInside: () => {
      setIsFocused(true);
    },
    onPointerDownOutside: (event) => {
      if (event.target && event.target instanceof HTMLElement && !optionsRef?.current?.contains(event.target)) {
        setIsFocused(false);
      }
    },
  });

  return [isFocused, setIsFocused];
};
